import "../css/homepage.css";
import { Water } from "../images/Water";
import { Alert } from "../images/Alert";
import { Notification } from "../images/Notification";
import { Location } from "../images/Location";
import { RightArrow } from "../images/RightArrow";
import { normalizeUnit } from "@utils/unitFormatter";

const FacilityCard = ({ data, onSelect }) => {
  if (!data) return null;

  const facilityData = data.data || data;
  
  const metrics = Array.isArray(facilityData.matrices) ? facilityData.matrices : [];
  const [metricsFirst, metricsSecond] = metrics;

  const unitFirst = metricsFirst ? normalizeUnit(metricsFirst.unit) : "";
  const unitSecond = metricsSecond ? normalizeUnit(metricsSecond.unit) : "";


  const hasNoData = metrics.length === 0;

  const handleCardClick = (e) => {
    // If onSelect is provided, prevent default navigation and call the callback
    if (onSelect && typeof onSelect === 'function') {
      e.preventDefault();
      onSelect(facilityData.facility_id || facilityData.id);
    }
    // If no onSelect callback, let the default link navigation work
  };

  return (
    <div className={`facility-card ${hasNoData ? "no-data" : ""}`}>
      <a 
        href={`/facility/${facilityData.facility_slug}`}
        onClick={handleCardClick}
        style={{ cursor: onSelect ? 'pointer' : 'default' }}
      >
        <div className="facility-card-wrap">
          <div className="facility-content">

            {/* ----- Title ----- */}
            <div className="title">
              <div className="icon">
                <Water />
                <div className="badge-label">
                  {Number(facilityData.alert_count) > 0 ? (
                    <Alert />
                  ) : Number(facilityData.notification_count) > 0 ? (
                    <Notification />
                  ) : null}
                </div>
              </div>

              <div className="content">
                <h4>{facilityData.facility_name}</h4>
                <div className="location">
                  <Location />  
                  <p>Near {facilityData.near_town}</p>
                </div>
              </div>
            </div>

            {/* ----- Metrics ----- */}
            <div className="facility-data">
              <div className="center-data">
                {metricsFirst && (
                  <>
                    <h4>
                      {metricsFirst.value}
                      {unitFirst && ` ${unitFirst}`}
                    </h4>
                    <p>{metricsFirst.description}</p>
                  </>
                )}
              </div>

              <div className="right-data">
                {metricsSecond && (
                  <>
                    <h4>
                      {metricsSecond.value}
                      {unitSecond && ` ${unitSecond}`}
                    </h4>
                    <p>{metricsSecond.description}</p>
                  </>
                )}
              </div>
            </div>

          </div>

          <div className="facility-card-arrow">
            <RightArrow />
          </div>
        </div>
      </a>
    </div>
  );
};

export default FacilityCard;
